import { useState } from "react";
import { impersonateOrganization } from "../../common/api/AdminDashboardClient";
import { handleError } from "../../common/ErrorHandling";

/**
 * Becomes an organization's bot user and loads the app as that org in this
 * tab, landing on `path` (the org's home page unless a caller asks for
 * somewhere else, such as a specific project).
 *
 * A full navigation, not a route change: the session user just changed, so
 * every piece of loaded state is stale. The bot keeps the super-admin role,
 * so the dashboard is still reachable from there.
 *
 * `impersonatingId` is the org currently being switched to, so a caller showing
 * one button per row can put the spinner on the right one.
 */
export const useImpersonateOrganization = () => {
    const [impersonatingId, setImpersonatingId] = useState<number>();

    const impersonate = async (orgId: number, path: string = "/") => {
        setImpersonatingId(orgId);
        try {
            await impersonateOrganization(orgId);
            // The destination is applied here in the browser, never handed to the
            // server, so impersonation gains no redirect parameter to abuse.
            window.location.assign(path);
        } catch (error) {
            handleError(error);
            setImpersonatingId(undefined);
        }
    };

    return { impersonate, impersonatingId };
};
